// import * as THREE from 'three';
import EventEmitter from "../../utils/EventEmitter";
import { UIPanel, UIImage, UITooltip } from "../ui.lib";

//Icon
import QRIcon from '../../../../assets/svgs/scenes/menu/qrcode.svg';


class MenubarQRCode extends EventEmitter {
    constructor(editor) {
        super();

        this.editor = editor;
        this.strings = this.editor.strings;
        this.dom = null;
        this.name = 'QR Code Access Point';
        this.isActive = false;
        this.editor.on('toggleMenuActive', this.onToggleMenuActive);

        this.initUI();
    }

    initUI = () => {

        this.uiCont = new UIPanel();
        this.uiCont.addClass('wsMenuContainer');
        this.uiCont.setId('wsMenuQRCode');
        
        this.uiText = new UITooltip(this.strings.getKey('menubar/qrcode'));
        this.uiImg = new UIImage(QRIcon, '28px', '28px', this.strings.getKey('menubar/qrcode'));

        this.uiCont.addChild(this.uiImg);
        this.uiCont.addChild(this.uiText);

        this.uiCont.onClick(() => {
            this.makeActive();
        })

        this.dom = this.uiCont.dom;
    }

    makeActive = () => {
        if(!this.isActive) {
            this.isActive = true;
            this.uiCont.addClass('wsMenuContainer--active');        
        }
        this.editor.trigger('toggleMenuActive', [this.name]);
        this.editor.trigger('sidebarSceneGraphChanged', [this.name]);
    }

    onToggleMenuActive = (name) => {
        if(name !== this.name) {
            this.isActive = false;
            this.uiCont.removeClass('wsMenuContainer--active');
        }
    }
}

export { MenubarQRCode };